import React from "react";
import { Wrapper, Icon } from "./styled";
import Help from "../../../../images/Icons/help.svg";

const HelpIcon = () => {
  return (
    <Wrapper>
      <Icon src={Help} alt="image" />
    </Wrapper>
  );
};

export default HelpIcon;
